import { render, staticRenderFns } from "./ClientSelection.vue?vue&type=template&id=b7d42bc6&"
import script from "./ClientSelection.vue?vue&type=script&lang=js&"
export * from "./ClientSelection.vue?vue&type=script&lang=js&"
import style0 from "./ClientSelection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports